'use client'

import { BlogCategoryFilters } from '@/features/blog/components/blog-category-filters'
import { BlogPageHeader } from '@/features/blog/components/blog-page-header'
import { BlogPostsSection } from '@/features/blog/components/blog-posts-section'
import { useBlogListing } from '@/features/blog/hooks/useBlogListing'

const shell = 'min-h-screen overflow-x-hidden bg-white'
const inner =
  'mx-auto w-full min-w-0 max-w-6xl px-4 pt-8 pb-10 sm:px-6 lg:max-w-7xl lg:px-8 lg:pt-10 lg:pb-14'

export default function BlogPageView({ serifHeadingClass }: { serifHeadingClass: string }) {
  const { filter, onFilterChange, grid } = useBlogListing()

  return (
    <div className={shell}>
      <div className={inner}>
        <BlogPageHeader />
        <BlogCategoryFilters activeFilter={filter} onFilterChange={onFilterChange} />
        <BlogPostsSection serifHeadingClass={serifHeadingClass} {...grid} />
      </div>
    </div>
  )
}
